import Button from '@components/common/Button';
import { Typography } from '@components/common/Typography';
import styled from 'styled-components';

export const ConnectWalletComponent = styled.div`
  height: 100%;
  display: flex;
  align-items: center;

  @media (max-width: ${({ theme }) => theme.breakPoints.md}) {
    display: none;
  }
`;

export const StyledButton = styled(Button)`
  display: flex;
  cursor: auto;
`;

export const AddressText = styled(Typography)`
  display: inline-block;
  line-height: 100%;
  font-family: ${({
    theme: {
      fonts: { mono },
    },
  }) => mono};
  color: ${({
    theme: {
      colors: {
        primary: { main },
      },
    },
  }) => main};
  letter-spacing: 1px;
  font-weight: 700;
`;

export const IconContainer = styled.div`
  width: 24px;
  height: 24px;
  line-height: 100%;
  margin-left: 0.5rem;
  cursor: pointer;
  svg {
    fill: ${({
      theme: {
        colors: {
          primary: { main },
        },
      },
    }) => main};
  }
`;
